export default __webpack_public_path__ + "static/media/icon-play-button.e9e96d2c.svg";